import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AuditProperties from './AuditProperties';
import { parseShortDateWithTime } from '../../../../utils/dates';

export default function PatternConfigurationDetails({ patterns }) {
  return (
    <React.Fragment>
      {patterns !== null &&
        patterns.map(pattern => (
          <div className="clinician-info-box">
            <Typography variant="h6" gutterBottom>
              Pattern Details
            </Typography>
            <div className="activities-table-wrapper">
              <div className="activities-table-head">
                <Grid container xs={12} sm={12}>
                  <Grid item xs={3} sm={3}>
                    <p>Recurrence Type</p>
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    <p>Recur Every</p>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <p>Time Type</p>
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    <p>Valid From</p>
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    <p>Valid To</p>
                  </Grid>
                </Grid>
              </div>
              <div className="content">
                <Box>
                  <Grid container spacing={0}>
                    <Grid item container xs={12} sm={12} className="info-wrapper">
                      <Grid item xs={3} sm={3}>
                        {pattern.recurrenceType}
                      </Grid>
                      <Grid item xs={2} sm={2}>
                        {pattern.every}
                      </Grid>
                      <Grid item xs={3} sm={3}>
                        {pattern.treatmentTimeType}
                      </Grid>
                      <Grid item xs={2} sm={2}>
                        {parseShortDateWithTime(pattern.validFrom)}
                      </Grid>
                      <Grid item xs={2} sm={2}>
                        {parseShortDateWithTime(pattern.validTo)}
                      </Grid>
                      <div style={{ marginTop: '20px' }}>
                        {pattern.auditEntryProperties && <AuditProperties props={pattern.auditEntryProperties} />}
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </div>
          </div>
        ))}
    </React.Fragment>
  );
}
